import { sizeToPixel } from '@beefco/core/utils';

// FIXME: '@beefco/core не должно быть в sdk
/**
 * this function is required to fix issues with sidebar,
 * caused by untracked layout changes
 */
export var simulateResize = function simulateResize() {
  var resizeEvent = window.document.createEvent('UIEvents');
  resizeEvent.initUIEvent('resize', true, false, window, 0);
  window.dispatchEvent(resizeEvent);
};
export var getWindowWidth = function getWindowWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

/** based on screen size, find current breakpoint */
export var getCurrentBreakpoint = function getCurrentBreakpoint(breakpoints, defaultSize) {
  return breakpoints.find(function (bp) {
    return sizeToPixel(bp) >= (defaultSize !== null && defaultSize !== void 0 ? defaultSize : getWindowWidth());
  });
};